const percentFormatter = new Intl.NumberFormat('en-GB', { maximumFractionDigits: 2 });
const countFormatter = new Intl.NumberFormat('en-GB');
const dateFormatter = new Intl.DateTimeFormat('en-GB', {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
});

export function formatPercent(value: number): string {
  return `${percentFormatter.format(value)}%`;
}

export function formatCount(value: number): string {
  return countFormatter.format(value);
}

export function formatRelativeTime(iso: string | null, now: Date = new Date()): string {
  if (iso === null) return 'never';

  const then = Date.parse(iso);
  if (Number.isNaN(then)) return 'never';

  const seconds = Math.round((now.getTime() - then) / 1000);
  if (seconds < 60) return `${Math.max(seconds, 0)}s ago`;
  if (seconds < 3_600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86_400) return `${Math.floor(seconds / 3_600)}h ago`;
  if (seconds < 2_592_000) return `${Math.floor(seconds / 86_400)}d ago`;
  return dateFormatter.format(new Date(then));
}

/**
 * Shortens a URL from the middle.
 *
 * Truncating the end would hide the very part that distinguishes two campaign
 * destinations from each other, which is the comparison this console exists to
 * support.
 */
export function truncateMiddle(value: string, max: number): string {
  if (value.length <= max) return value;
  const keep = max - 1;
  const head = Math.ceil(keep * 0.55);
  const tail = keep - head;
  return `${value.slice(0, head)}…${value.slice(value.length - tail)}`;
}
